import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import Patient from './../../../components/Patients/Patient/PatientDetails';
import { getPatient, syncPatient, resetPatientSync } from '../../../actions/entities/patients';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { getSettings } from '../../../actions/entities';
import { ENABLE_SETTING_PATIENTS_AS_INACTIVE } from '../../../settings/constants/appSettings';

const mapStateToProps = ({ entities: { patients, settings }, global: { auth } }) => ({
  isFetching: patients.previewed.isFetching,
  patient: patients.previewed.patient,
  toggleReload: patients.previewed.toggleReload,
  message: patients.previewed.message,
  isSnackBarOpen: patients.previewed.isSnackBarOpen,
  syncFailed: patients.previewed.syncFailed,
  canEditPatients: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditPatients),
  canEditReferrals: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditReferrals),
  canAddReferrals: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddReferrals),
  canAddTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddTreatments),
  canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
  enableIntegrationMode: checkFeatureAccess(
    auth.featureAccessList,
    globals.applicationFeatureAccesses.enableIntegrationMode,
  ),
  enableSettingPatientsAsInactive: settings.appSettings[ENABLE_SETTING_PATIENTS_AS_INACTIVE],
});

const mapDispatchToProps = dispatch => ({
  getPatient: patientId => dispatch(getPatient(patientId)),
  syncPatient: patientId => dispatch(syncPatient(patientId)),
  resetPatientSync: () => dispatch(resetPatientSync()),
  goBack: () => dispatch(goBack()),
  go: url => dispatch(push(url)),
  getAppSettings: settingsName => {
    dispatch(getSettings(settingsName));
  },
});

const PatientContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Patient);

export default PatientContainer;
